import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@savgroup-front-common/primitive/ui/sheet';

import { SelectSellerControl } from '../SelectSellerControl/SelectSellerControl';

import messages from './messages';

interface SelectSellerSheetProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSelected: () => void;
  dataTestId?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export const SelectSellerSheet: FC<SelectSellerSheetProps> = ({
  isOpen,
  onOpenChange,
  onSelected,
  dataTestId,
  side = 'right',
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent
        side={side}
        data-testid={dataTestId}
        className="data-[side=left]:sm:max-w-2xl data-[side=right]:sm:max-w-2xl"
      >
        <SheetHeader>
          <SheetTitle>
            {safeFormattedIntlString(messages.selectSeller)}
          </SheetTitle>
        </SheetHeader>

        <div className="flex min-h-0 flex-1 flex-col gap-4 px-4 pb-4">
          <SelectSellerControl
            onClose={() => {
              onOpenChange(false);
              onSelected();
            }}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};
